var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0C13.5 0 10 1 10 5.5V9C10 10.1031 10.8969 11 12 11H13V15C13 15.5531 13.4469 16 14 16C14.5531 16 15 15.5531 15 15V11V7.5V1C15 0.446875 14.5531 0 14 0ZM3 0.5C3 0.24375 2.80938 0.03125 2.55313 0.003125C2.29688 -0.025 2.06875 0.14375 2.0125 0.390625L1.06562 4.65C1.02187 4.84688 1 5.04688 1 5.24687C1 6.68125 2.09687 7.85938 3.5 7.9875V15C3.5 15.5531 3.94688 16 4.5 16C5.05312 16 5.5 15.5531 5.5 15V7.9875C6.90312 7.85938 8 6.68125 8 5.24687C8 5.04688 7.97812 4.84688 7.93437 4.65L6.9875 0.390625C6.93125 0.140625 6.69688 -0.025 6.44375 0.003125C6.19062 0.03125 6 0.24375 6 0.5V4.69375C6 4.8625 5.8625 5 5.69375 5C5.53437 5 5.40312 4.87813 5.3875 4.71875L4.99688 0.45625C4.975 0.196875 4.75938 0 4.5 0C4.24062 0 4.025 0.196875 4.00312 0.45625L3.61562 4.71875C3.6 4.87813 3.46875 5 3.30938 5C3.14062 5 3.00312 4.8625 3.00312 4.69375V0.5H3ZM4.50938 5.25H4.5H4.49062L4.5 5.22813L4.50938 5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.ab660b61f4ca2c337cded7a2adcd6c0b.svg";
export { ForwardRef as ReactComponent };